<template>
    <DModal
        :show="showModal"
        :title="__('settings.set_limits.warning_modal_title')"
        :message="__('settings.set_limits.warning_modal_description')"
        is-confirm
        is-error
        @confirm="$emit('confirm-modal')"
        @close="$emit('close-modal')"
    />
</template>

<script setup>

defineProps({
    showModal: {
        type: Boolean,
        default: false
    }
})

defineEmits(['close-modal', 'confirm-modal'])
</script>
